import React, { useEffect, useState } from 'react'
import File from '../../assets/img/file@2x.png'
import { FileInputContainer } from '../../Containers/PasserCommande/PasserCommande.styles'
import SimulateWaypoints from '../PointsPassages/SimulateWaypointsExistingMission'
import { simulateExistingMissionWaypoints } from '../../api/commande'
import { Route, Trash2 } from 'lucide-react'
import toast from 'react-hot-toast'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

function UploadRouteLetterFile({
	onClose,
	name,
	initialFiles,
	maxFileSize = 10 * 1024 * 1024,
	onChange,
	simulation,
	onSimulationComplete,
	missionId = null,
}) {
	const [file, setFile] = useState(initialFiles || null)
	const [loading, setLoading] = useState(false)
	const [showSimulationModal, setShowSimulationModal] = useState(false)
	const [simulationData, setSimulationData] = useState(simulation || null)
	const token = useSelector((state) => state.auth.token)
	const {t} = useTranslation();
	const acceptedTypes = [
		'application/pdf',
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		'application/vnd.ms-excel',
		'text/csv',
		'application/csv',
	]
	const acceptString = '.pdf,.xls,.xlsx,.csv'

	const handleClose = () => {
		setShowSimulationModal(false)
		handleRemoveFile()
	}
	// Mettre à jour le fichier et la simulation quand les props changent
	useEffect(() => {
		if (initialFiles !== undefined) {
			setFile(initialFiles)
		}
		if (simulation !== undefined) {
			setSimulationData(simulation)
		}
	}, [initialFiles, simulation])

	// Effectue la simulation avec les paramètres actuels
	const recalculateSimulation = async (fileToProcess) => {
		if (!fileToProcess || !missionId) return

		try {
			setLoading(true)
			// Utilise la simulation pour mission existante
			const simulationData = await simulateExistingMissionWaypoints(
				{
					missionId,
				},
				fileToProcess,
				token
			)

			if (simulationData.status) {
				setSimulationData(simulationData)
				setShowSimulationModal(true)
				if (onSimulationComplete) {
					onSimulationComplete(simulationData)
				}
				if (onChange) {
					onChange(fileToProcess)
				}
			} else {
				throw new Error(
					simulationData.message || t("simulation_failed")
				)
			}
		} catch (error) {
			toast.error(
				error.response?.data?.message ||
					error.response?.data?.error ||
					t("error_while_simulating_waybill"),
				{
					style: { fontFamily: 'Montserrat' },
				}
			)
		} finally {
			setLoading(false)
		}
	}

	// Gère le changement de fichier
	const handleFileChange = async (e) => {
		try {
			const selectedFile = e.target.files[0]
			if (!selectedFile) return

			// Validation du fichier
			if (selectedFile.size > maxFileSize) {
				toast.error(`${t("large_file")} (max 10MB)`, {
					style: { fontFamily: 'Montserrat' },
				})
				return
			}

			if (!acceptedTypes.includes(selectedFile.type)) {
				toast.error(t("accepted_file_types"), {
					style: { fontFamily: 'Montserrat' },
				})
				return
			}

			setFile(selectedFile)
			recalculateSimulation(selectedFile)
		} catch (error) {
			toast.error(t("error_processing_file"))
		}
	}

	// Gère la suppression du fichier
	const handleRemoveFile = () => {
		setFile(null)
		setSimulationData(null)
		if (onChange) onChange(null)
		if (onSimulationComplete) onSimulationComplete(null)
		onClose()
	}

	const handleViewRoute = (e) => {
		e.preventDefault()
		e.stopPropagation()

		if (simulationData) {
			setShowSimulationModal(true)
		} else {
			toast.error(t("no_simulation_data"), {
				style: { fontFamily: 'Montserrat' },
			})
		}
	}
    const [isSmallScreen, setSmallScreen] = useState(() => window.innerWidth < 768);   
	useEffect(() => {
		const checkIfMobile = () => {
			setSmallScreen(window.innerWidth < 768);
		};
		window.addEventListener('resize', checkIfMobile);
   
		return () => window.removeEventListener('resize', checkIfMobile);
	}, []);
	return (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
			}}
		>
			<div
				style={{
					display: 'flex',
					flexDirection : isSmallScreen && file ? "column" : "row",
					gap : isSmallScreen && file ? "1rem" :0,
					flex: 1,
					borderRadius: '0.75rem',
					background: 'white',
					alignItems: 'center',
					justifyContent: 'space-between',
					marginBottom: '1.5rem',
					position: 'relative',
					opacity: 1,
					border: `2px dashed  #dee2e6`,
					transition: 'all 0.3s ease',
					padding: '0.75rem',
					'&:hover': {
						borderColor: '#2a9fd6',
						boxShadow: '0 2px 8px rgba(81, 199, 242, 0.15)',
					},
				}}
			>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: '1rem',
						flex: 1,
					}}
				>
					{file ? (
						<>
							<div
								style={{
									background: '#e3f8ff',
									borderRadius: '8px',
									padding: '0.5rem',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
								}}
							>
								<img
									src={File}
									style={{
										height: 28,
										width: 28,
										filter: 'invert(56%) sepia(74%) saturate(378%) hue-rotate(161deg) brightness(91%) contrast(93%)',
									}}
									alt='Fichier'
								/>
							</div>
							<div style={{ flex: 1 }}>
								<p
									style={{
										margin: 0,
										fontWeight: 500,
										color: '#212529',
										fontSize: '0.9rem',
										overflow: 'hidden',
										textOverflow: 'ellipsis',
									}}
								>
									{file.name}
								</p>
								<p
									style={{
										margin: 0,
										color: '#868e96',
										fontSize: '0.75rem',
										marginTop: '0.25rem',
									}}
								>
									{Math.round(file.size / 1024)} KB
								</p>
							</div>
						</>
					) : (
						<span
							style={{
								color: '#868e96',
								fontStyle: 'italic',
								fontSize: '0.9rem',
							}}
						>
							{t("no_file_selected")}
						</span>
					)}
				</div>
				<div style={{display : "flex" , flexDirection :  "row"}}>
                
				<FileInputContainer>
					<input
						type='file'
						id={name}
						name={name}
						className='file'
						accept={acceptString}
						onChange={handleFileChange}
						disabled={loading}
						style={{ cursor: loading ? 'not-allowed' : 'pointer' }}
					/>
					<label
						htmlFor={name}
						style={{
							cursor: loading ? 'not-allowed' : 'pointer',
							backgroundColor: loading ? '#e9ecef' : '#f1f3f5',
							color: loading ? '#adb5bd' : '#212529',
							padding: '0.5rem 1rem',
							borderRadius: '6px',
							fontSize: '0.875rem',
							fontWeight: 500,
							transition: 'all 0.2s ease',
							'&:hover': !loading && {
								backgroundColor: '#e3f8ff',
								color: '#087ea4',
							},
							
						}}
					>
						{loading ? (
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									gap: '0.5rem',
								}}
							>
								<div
									className='loader'
									style={{ width: '16px', height: '16px' }}
								/>
								{t("loading")}...
							</div>
						) : (
							t("select_file")
						)}
					</label>
				</FileInputContainer>
				{file && (
					<button
						onClick={handleRemoveFile}
						style={{
							marginLeft: '1rem',
							background: 'transparent',
							border: 'none',
							color: '#dc2626',
							cursor: 'pointer',
							display: 'flex',
							alignItems: 'center',
						}}
						disabled={loading}
					>
						<Trash2 size={18} />
					</button>
				)}
				</div>

				<SimulateWaypoints
					isOpen={showSimulationModal}
					onClose={handleClose}
					simulation={simulationData}
					setSimulation={setSimulationData}
					missionId={missionId}
					file={initialFiles}
				/>
			</div>
			{/* Ajout du bouton d'affichage de la simulation */}
			{simulationData && (
				<button
					type='button'
					onClick={handleViewRoute}
					style={{
						marginLeft: '1rem',
						padding: '0.75rem 1.5rem',
						backgroundColor: '#f0fbff',
						color: '#087ea4',
						border: '2px solid #c5f3ff',
						borderRadius: '8px',
						cursor: 'pointer',
						display: 'flex',
						alignItems: 'center',
						gap: '0.75rem',
						fontSize: '0.875rem',
						fontWeight: 600,
						transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
						boxShadow: '0 2px 4px rgba(8, 126, 164, 0.1)',
						'&:hover': {
							backgroundColor: '#c5f3ff',
							transform: 'translateY(-2px)',
							boxShadow: '0 4px 8px rgba(8, 126, 164, 0.15)',
							borderColor: '#9ae3ff',
						},
						'&:active': {
							transform: 'translateY(0)',
							boxShadow: '0 2px 4px rgba(8, 126, 164, 0.1)',
						},
					}}
				>
					<Route
						size={20}
						style={{
							strokeWidth: '2px',
							color: '#087ea4',
							transition: 'transform 0.3s ease',
						}}
					/>
					<span>{t("view_route")}</span>
				</button>
			)}
		</div>
	)
}

export default UploadRouteLetterFile

